function checkRequiredSpaces(buildingAttributes, rules, optional = []) {
    const result = [];
    const spaces = rules.filter(rule => !rule.userSelectable || optional.some(option => option.name === rule.name));
    // check each space that needs to be added
    for (const rule of spaces) {
        let required = true;
        const conditions = rule.conditions;
        const properties = Object.keys(conditions);
        // check each condition against the respective building attribute
        for (const property of properties) {
            const condition = conditions[property];
            const buildingAttribute = buildingAttributes[property];
            if (Array.isArray(condition) && condition.length === 2 && typeof buildingAttribute === 'number') {
                // check if attribute is within range, exclusive of end limit
                required = buildingAttribute >= condition[0] && buildingAttribute < condition[1];
                if (!required)
                    break;
            }
            else if (typeof condition === 'boolean') {
                // if incoming `buildingAttributes` are missing a boolean attribute, assume it is `false`
                required = buildingAttribute ? condition === buildingAttribute : !condition;
                if (!required)
                    break;
            }
            else if (typeof condition === 'string' && typeof buildingAttribute === 'string') {
                required = condition.toLocaleLowerCase() === buildingAttribute?.toLocaleLowerCase();
                if (!required)
                    break;
            }
        }
        if (required)
            result.push(rule);
    }
    return result;
}

export { checkRequiredSpaces };
//# sourceMappingURL=check-building.js.map
